import React, {
    Component,
    Fragment,
} from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'

export default class CollapsibleSection extends Component {
    static propTypes = {
        defaultCollapsed: PropTypes.bool,
        title: PropTypes.any.isRequired,
    };

    static defaultProps = {
        defaultCollapsed: false,
    };

    constructor(props) {
        super(props)

        this.state = {
            collapsed: this.props.defaultCollapsed,
        }
    }

    componentDidMount() {
        this.body.addEventListener('invalid', this.openOnInvalid, true)
    }

    componentWillUnmount() {
        this.body.removeEventListener('invalid', this.openOnInvalid)
    }

    openOnInvalid = () => {
        this.setState({ collapsed: false })
    }

    toggleCollapsed = () => {
        this.setState({ collapsed: !this.state.collapsed })
    }

    render() {
        const { collapsed } = this.state

        const {
            children,
            title,
            iconText,
            notClickableHeading,
            bigArrow,
        } = this.props

        return (
            <Fragment>
                <div
                    className="card-header clickable font-weight-bold card-header-activable"
                    onClick={notClickableHeading ? null : this.toggleCollapsed}
                >
                    <div className="d-flex flex-row">
                        <div
                            onClick={notClickableHeading ? this.toggleCollapsed : null}
                            className={classnames({
                                'd-flex pl-2 position-absolute align-items-center bg-white text-color-neutral text-hover-underline': iconText,
                            })}
                        >
                            {iconText &&
                                <span>{iconText}&nbsp;</span>
                            }
                            <i
                                className={classnames({
                                    'fa mr-3': true,
                                    'fa-caret-up': !collapsed && !bigArrow,
                                    'fa-caret-down': collapsed && !bigArrow,
                                    'fa-angle-up': !collapsed && bigArrow,
                                    'fa-angle-down': collapsed && bigArrow,
                                })}
                            />
                        </div>
                        <div className="w-100">{title}</div>
                    </div>
                </div>
                <div
                    className={classnames({
                        'card-body': true,
                        'd-none': collapsed,
                    })}
                    ref={node => (this.body = node)}
                >
                    {children}
                </div>
            </Fragment>
        )
    }
}
